export default __webpack_public_path__ + "static/rec-2023-a6d24c8148d5948a7828afcd816b550f.png";